import { render, staticRenderFns } from "./OrdManageDetail.vue?vue&type=template&id=06bfc208"
import script from "./OrdManageDetail.vue?vue&type=script&lang=js"
export * from "./OrdManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports